import React from "react";
const InputWrapper = ({ children, className = void 0, wrapperAttributes = void 0 }) => className ? /* @__PURE__ */ React.createElement("div", { ...wrapperAttributes, className }, children) : /* @__PURE__ */ React.createElement("span", { ...wrapperAttributes }, children);
export default InputWrapper;
